// extracted by mini-css-extract-plugin
module.exports = {"pixExpirationField":"PaymentSettings_pixExpirationField__2MlAY"};